import { useState, useEffect, useRef, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useSendManager } from "../context/SendManagerContext";
import { ACCESS_TOKEN } from "../constants";
import api from "../api";
import { Sidebar } from "../components/Note";
import "../styles/NoteDashboard.css";
import UserMenu from "../components/UserMenu";

// Campanias (Mensajes) - versión con diseño mejorado del hea

function Mensajes() {
  // Vista principal de la página: listado de campañas o creador de campaña
  const [view, setView] = useState("index"); // 'index' | 'create'
  const [summary, setSummary] = useState([]);
  const [summaryLoading, setSummaryLoading] = useState(false);
  const navigate = useNavigate();
  // Detalle de envíos por campaña (modal desde el listado)
  const [detailOpen, setDetailOpen] = useState(false);
  const [detailLoading, setDetailLoading] = useState(false);
  const [detailError, setDetailError] = useState("");
  const [detailCampaign, setDetailCampaign] = useState(null); // {id,nombre,clientes,lista_nombre}
  const [detailRuns, setDetailRuns] = useState([]); // [{run_id,label,started_at,ended_at,total,contacts:[...]}]
  const [detailSelectedRun, setDetailSelectedRun] = useState(0);
  const [detailRunFilterDate, setDetailRunFilterDate] = useState(""); // YYYY-MM-DD (único)
  const [detailContactQuery, setDetailContactQuery] = useState("");

  const filteredRuns = useMemo(() => {
    if (!Array.isArray(detailRuns)) return [];
    // Si hay fecha seleccionada, filtrar corridas de ese día (00:00:00 a 23:59:59)
    if (detailRunFilterDate) {
      const dayStart = new Date(`${detailRunFilterDate}T00:00:00`);
      const dayEnd = new Date(`${detailRunFilterDate}T23:59:59`);
      return detailRuns.filter((r) => {
        const d = r?.started_at ? new Date(r.started_at) : null;
        return !!d && d >= dayStart && d <= dayEnd;
      });
    }
    return detailRuns;
  }, [detailRuns, detailRunFilterDate]);

  useEffect(() => {
    if (detailSelectedRun >= filteredRuns.length) setDetailSelectedRun(0);
  }, [filteredRuns.length]);

  // Toasts simples
  const [toast, setToast] = useState(null); // { message, type }
  const toastTimerRef = useRef(null);
  const showToast = (message, type = "info", duration = 3000) => {
    setToast({ message, type });
    if (toastTimerRef.current) clearTimeout(toastTimerRef.current);
    toastTimerRef.current = setTimeout(() => setToast(null), duration);
  };

  const [username, setUsername] = useState("");
  // Decodificar JWT para obtener username y luego cargar preferencias
  useEffect(() => {
    // Primero intentar recuperar username directo (guardado en Login)
    const storedUsername = localStorage.getItem("username");
    if (storedUsername) {
      setUsername(storedUsername);
      const saved = JSON.parse(
        localStorage.getItem(`plantillasSeleccionadas_${storedUsername}`)
      );
      if (saved) {
        setPlantilla1(saved[0] || "");
        setPlantilla2(saved[1] || "");
        setPlantilla3(saved[2] || "");
        setPlantilla4(saved[3] || "");
        setPlantilla5(saved[4] || "");
      }
      return; // ya cargamos
    }
    // Si no existe username guardado, intentar decodificar token
    const token = localStorage.getItem(ACCESS_TOKEN);
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split(".")[1]));
        const decodedUsername =
          payload?.username || payload?.user || payload?.user_id || payload?.sub; // varios posibles campos
        if (decodedUsername) {
          setUsername(decodedUsername);
          const saved = JSON.parse(
            localStorage.getItem(`plantillasSeleccionadas_${decodedUsername}`)
          );
          if (saved) {
            setPlantilla1(saved[0] || "");
            setPlantilla2(saved[1] || "");
            setPlantilla3(saved[2] || "");
            setPlantilla4(saved[3] || "");
            setPlantilla5(saved[4] || "");
          }
        }
      } catch (_) {
        /* ignorar */
      }
    }
  }, []);

  // Cargar resumen de campañas para el listado principal
  useEffect(() => {
    if (view !== "index") return;
    setSummaryLoading(true);
    api
      .get("campanas/summary/")
      .then((res) => setSummary(Array.isArray(res.data) ? res.data : []))
      .catch(() => setSummary([]))
      .finally(() => setSummaryLoading(false));
  }, [view]);

  const openCampaignDetails = async (campId) => {
    try {
      setDetailError("");
      setDetailLoading(true);
      setDetailOpen(true);
      const { data } = await api.get(`campanas/${campId}/envios/`);
      setDetailCampaign(data?.campaign || null);
      setDetailRuns(Array.isArray(data?.runs) ? data.runs : []);
      setDetailSelectedRun(0);
    } catch (e) {
      setDetailError(e?.message || "No se pudo cargar el detalle");
    } finally {
      setDetailLoading(false);
    }
  };

  const [listaClientes, setListaClientes] = useState("");
  // Listas de contactos reales desde backend
  const [listasDisponibles, setListasDisponibles] = useState([]);
  // Plantillas reales desde backend
  const [plantillasDisponibles, setPlantillasDisponibles] = useState([]);
  const [plantilla1, setPlantilla1] = useState("");
  const [plantilla2, setPlantilla2] = useState("");
  const [plantilla3, setPlantilla3] = useState("");
  const [plantilla4, setPlantilla4] = useState("");
  const [plantilla5, setPlantilla5] = useState("");
  const [showCampanasMenu, setShowCampanasMenu] = useState(false);
  const [showClientesMenu, setShowClientesMenu] = useState(false);
  const [showPlantillasMenu1, setShowPlantillasMenu1] = useState(false);
  const [showPlantillasMenu2, setShowPlantillasMenu2] = useState(false);
  const [showPlantillasMenu3, setShowPlantillasMenu3] = useState(false);
  const [showPlantillasMenu4, setShowPlantillasMenu4] = useState(false);
  const [showPlantillasMenu5, setShowPlantillasMenu5] = useState(false);
  const [sendNow, setSendNow] = useState(true);
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  // Envío secuencial
  const [previewOpen, setPreviewOpen] = useState(false);
  const {
    job,
    scheduleJob,
    startJob,
    stopJob,
    startServerBatch,
    batch,
    cancelServerBatch,
  } = useSendManager();
  const [sending, setSending] = useState(false);
  const [stopRequested, setStopRequested] = useState(false);
  const [recipients, setRecipients] = useState([]); // [{id, full_name, phone, email}]
  const [sendProgress, setSendProgress] = useState({
    total: 0,
    sent: 0,
    failed: 0,
    current: 0,
  });
  const sendTimerRef = useRef(null);
  // Media opcional adjunta por el usuario para esta corrida
  const [overrideImageUrl, setOverrideImageUrl] = useState("");
  const [uploadingImage, setUploadingImage] = useState(false);
  const [overrideTargetSlot, setOverrideTargetSlot] = useState(null); // nro de plantilla a la que aplicar

  // Estado de conexión de WhatsApp (para mostrar en la vista previa)
  const [waReady, setWaReady] = useState(null); // null=cargando, true=conectada, false=en espera
  const refreshWaStatus = async () => {
    try {
      const { data } = await api.get('whatsapp/status/');
      setWaReady(!!data?.ready);
    } catch (_) {
      setWaReady(false);
    }
  };

  // Estado para nombre de campaña y campañas guardadas
  const [nombreCampana, setNombreCampana] = useState("");
  const [campanasGuardadas, setCampanasGuardadas] = useState([]);
  const [campanaSeleccionada, setCampanaSeleccionada] = useState("");
  const [loading, setLoading] = useState(false);
  const [campanasError, setCampanasError] = useState("");
  const [isSaving, setIsSaving] = useState(false);

  // --- NUEVO: tema claro/oscuro (persistente) ---
  const [dark, setDark] = useState(localStorage.getItem("theme") === "dark");
  useEffect(() => {
    document.documentElement.classList.toggle("dark", dark);
    localStorage.setItem("theme", dark ? "dark" : "light");
  }, [dark]);
  // ------------------------------------------------

  // Actualizar estado de WhatsApp al abrir la vista previa
  useEffect(() => {
    if (previewOpen) refreshWaStatus();
  }, [previewOpen]);

  // Cargar campañas desde cache local cuando sepamos el username
  useEffect(() => {
    // Prefill desde Calendario (si existe)
    try {
      const d = localStorage.getItem("prefCalDate");
      if (d) {
        setSendNow(false);
        setDate(d);
        // Si el día seleccionado es hoy, prefijar siguiente hora redondeada, si no, 09:00
        const today = new Date();
        const [yy, mm, dd] = d.split("-").map(Number);
        const isToday =
          today.getFullYear() === yy &&
          today.getMonth() + 1 === mm &&
          today.getDate() === dd;
        if (isToday) {
          const t = new Date();
          t.setMinutes(t.getMinutes() + 30);
          t.setSeconds(0);
          t.setMilliseconds(0);
          const hh = String(t.getHours()).padStart(2, "0");
          const mi = String(t.getMinutes()).padStart(2, "0");
          setTime(`${hh}:${mi}`);
        } else {
          setTime("09:00");
        }
        localStorage.removeItem("prefCalDate");
      }
      const prefCamp = localStorage.getItem("prefSelectedCampaignId");
      if (prefCamp) {
        setCampanaSeleccionada(String(prefCamp));
        localStorage.removeItem("prefSelectedCampaignId");
      }
    } catch {}
    if (!username) return;
    try {
      const cached = localStorage.getItem(`campanas_${username}`);
      if (cached) {
        const arr = JSON.parse(cached);
        if (Array.isArray(arr)) setCampanasGuardadas(arr);
      }
    } catch (_) {}
  }, [username]);

  // Obtener campañas del usuario desde backend
  useEffect(() => {
    setLoading(true);
    setCampanasError("");
    api
      .get("campanas/")
      .then((res) => {
        const serverList = Array.isArray(res.data) ? res.data : [];
        setCampanasGuardadas((prev) => {
          if (serverList.length === 0) {
            // No sobrescribir una lista válida (optimista o de caché) con vacío
            return prev;
          }
          // Fusionar por id (server gana)
          const map = new Map();
          prev.forEach((c) => map.set(String(c.id), c));
          serverList.forEach((c) => map.set(String(c.id), c));
          const merged = Array.from(map.values());
          if (username) {
            localStorage.setItem(
              `campanas_${username}`,
              JSON.stringify(merged)
            );
          }
          return merged;
        });
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        setCampanasError(
          "No se pudieron cargar las campañas (¿servidor caído o sin sesión?)"
        );
        console.error("Error cargando campañas", err);
      });
  }, [username]);

  // Cuando se selecciona una campaña guardada, reconstruir selección de plantillas y otros campos
  useEffect(() => {
    if (!campanaSeleccionada) return;
    const camp = campanasGuardadas.find(
      (c) => String(c.id) === String(campanaSeleccionada)
    );
    if (!camp) return;
    // Nombre
    if (camp.nombre && camp.nombre !== nombreCampana) setNombreCampana(camp.nombre);
    // Plantillas
    if (Array.isArray(camp.plantillas)) {
      if (camp.plantillas[0] !== undefined && camp.plantillas[0] !== plantilla1)
        setPlantilla1(camp.plantillas[0] || "");
      if (camp.plantillas[1] !== undefined && camp.plantillas[1] !== plantilla2)
        setPlantilla2(camp.plantillas[1] || "");
      if (camp.plantillas[2] !== undefined && camp.plantillas[2] !== plantilla3)
        setPlantilla3(camp.plantillas[2] || "");
      if (camp.plantillas[3] !== undefined && camp.plantillas[3] !== plantilla4)
        setPlantilla4(camp.plantillas[3] || "");
      if (camp.plantillas[4] !== undefined && camp.plantillas[4] !== plantilla5)
        setPlantilla5(camp.plantillas[4] || "");
    }
    // Clientes
    if (camp.clientes && String(camp.clientes) !== String(listaClientes))
      setListaClientes(String(camp.clientes));
    // Fecha
    if (camp.fecha) {
      if (camp.fecha === "inmediato" && !sendNow) setSendNow(true);
      else if (camp.fecha !== "inmediato") {
        if (sendNow) setSendNow(false);
        const partes = camp.fecha.split(" ");
        if (partes.length === 2) {
          const [f, h] = partes;
          if (f && f !== date) setDate(f);
          if (h && h !== time) setTime(h);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [campanaSeleccionada, campanasGuardadas]);

  // Obtener plantillas (notes) reales
  useEffect(() => {
    api
      .get("notes/")
      .then((res) => setPlantillasDisponibles(res.data || []))
      .catch((err) => console.error("Error cargando plantillas", err));
  }, []);

  // Obtener listas de contactos reales
  useEffect(() => {
    api
      .get("listas/")
      .then((res) => {
        const arr = Array.isArray(res.data) ? res.data : [];
        setListasDisponibles(arr);
      })
      .catch((err) => console.error("Error cargando listas de contactos", err));
  }, []);

  // Guardar campaña en el backend
  const guardarCampana = () => {
    if (!nombreCampana) {
      showToast("Debes ingresar un nombre para la campaña", "warning");
      return;
    }
    // Evitar nombres duplicados (ignorando mayúsculas/minúsculas y espacios)
    const nombreNorm = String(nombreCampana || "").trim().toLowerCase();
    if (
      nombreNorm &&
      campanasGuardadas.some(
        (c) => String(c?.nombre || "").trim().toLowerCase() === nombreNorm
      )
    ) {
      showToast("Ya existe una campaña con ese nombre. Usa otro nombre.", "warning");
      return;
    }
    const plantillasArray = [
      plantilla1,
      plantilla2,
      plantilla3,
      plantilla4,
      plantilla5,
    ];
    const seleccionadas = plantillasArray.filter(Boolean);
    if (seleccionadas.length < 4) {
      showToast(
        "Debes seleccionar al menos 4 plantillas antes de guardar",
        "warning"
      );
      return;
    }
    // Requerir selección de lista de clientes
    const clientesId = String(listaClientes || "").trim();
    if (!clientesId) {
      showToast("Selecciona una lista de clientes antes de guardar.", "warning");
      return;
    }
    setIsSaving(true);
    api
      .post("campanas/", {
        nombre: nombreCampana,
        plantillas: seleccionadas,
        clientes: clientesId,
        fecha: sendNow ? "inmediato" : `${date} ${time}`,
      })
      .then((res) => {
        const nueva = res.data;
        // Guardar localmente optimista
        setCampanasGuardadas((prev) => {
          const next = [...prev, nueva];
          if (username)
            localStorage.setItem(`campanas_${username}`, JSON.stringify(next));
          return next;
        });
        setCampanaSeleccionada(String(nueva.id));
        // Persistir selección de plantillas para este usuario
        if (username) {
          localStorage.setItem(
            `plantillasSeleccionadas_${username}`,
            JSON.stringify(plantillasArray)
          );
        }
        setNombreCampana("");
        showToast("Campaña guardada exitosamente", "success");
        // Refrescar desde backend para sincronizar, sin perder la campaña local si el servidor devuelve vacío
        api
          .get("campanas/")
          .then((r) => {
            const serverList = Array.isArray(r.data) ? r.data : [];
            setCampanasGuardadas((prev) => {
              if (serverList.length === 0) {
                if (username)
                  localStorage.setItem(`campanas_${username}`, JSON.stringify(prev));
                return prev;
              }
              const map = new Map();
              prev.forEach((c) => map.set(String(c.id), c));
              serverList.forEach((c) => map.set(String(c.id), c));
              const merged = Array.from(map.values());
              if (username)
                localStorage.setItem(
                  `campanas_${username}`,
                  JSON.stringify(merged)
                );
              return merged;
            });
            setIsSaving(false);
          })
          .catch(() => {
            setIsSaving(false);
          });
      })
      .catch((err) => {
        let msg = "Error al guardar campaña";
        if (err.response) {
          msg += ` (status ${err.response.status})`;
          if (typeof err.response.data === "string") msg += `: ${err.response.data}`;
          else if (err.response.data && typeof err.response.data === "object")
            msg += `: ${JSON.stringify(err.response.data)}`;
        } else if (err.message) {
          msg += `: ${err.message}`;
        }
        showToast(msg, "error", 5000);
        setIsSaving(false);
        console.error("Error guardar campaña", err);
      });
  };

  // Eliminar campaña
  const eliminarCampana = (id) => {
    api
      .delete(`campanas/delete/${id}/`)
      .then((res) => {
        if (res.status === 204) {
          const next = campanasGuardadas.filter((c) => c.id !== id);
          setCampanasGuardadas(next);
          if (username) {
            localStorage.setItem(`campanas_${username}`, JSON.stringify(next));
          }
          showToast("Campaña eliminada", "success");
        } else {
          showToast("No se pudo eliminar", "warning");
        }
      })
      .catch(() => showToast("Error al eliminar", "error"));
  };

  // Helper para mostrar nombre en botón según selección (buscando por id de nota)
  const obtenerNombrePlantilla = (id) => {
    if (!id) return null;
    const p = plantillasDisponibles.find((pt) => String(pt.id) === String(id));
    return p ? p.title : null;
  };

  const getSelectedTemplateEntries = () => {
    const entries = [
      { slot: 1, id: plantilla1 },
      { slot: 2, id: plantilla2 },
      { slot: 3, id: plantilla3 },
      { slot: 4, id: plantilla4 },
      { slot: 5, id: plantilla5 },
    ];
    return entries
      .filter((e) => !!e.id)
      .map((e) => ({
        ...e,
        data:
          plantillasDisponibles.find((p) => String(p.id) === String(e.id)) ||
          null,
      }));
  };

  // Devuelve las plantillas seleccionadas (4 o 5) como objetos completos (id, title, content)
  const getSelectedTemplates = () => {
    const ids = [plantilla1, plantilla2, plantilla3, plantilla4, plantilla5];
    const arr = ids
      .map((id) =>
        plantillasDisponibles.find((p) => String(p.id) === String(id))
      )
      .filter(Boolean);
    return arr;
  };

  // Convierte HTML a texto plano preservando saltos de línea y espacios razonables
  const htmlToPlain = (html) => {
    try {
      let s = String(html || "");
      // Convertir saltos de línea semánticos antes de eliminar tags
      s = s.replace(/<\s*br\s*\/?>/gi, "\n");
      s = s.replace(/<\/(p|div|h[1-6]|li)\s*>/gi, "\n");
      // Opcional: prefijo de viñetas para <li>
      s = s.replace(/<li[^>]*>/gi, "• ");
      // Eliminar el resto de etiquetas
      s = s.replace(/<[^>]+>/g, "");
      // Decodificar entidades HTML (&nbsp; &amp;, etc.)
      const ta = document.createElement("textarea");
      ta.innerHTML = s;
      s = ta.value;
      // Reemplazar espacios no separables por espacios normales
      s = s.replace(/\u00A0/g, " ");
      // Normalizar CRLF a LF
      s = s.replace(/\r\n/g, "\n");
      return s;
    } catch {
      return String(html || "");
    }
  };

  const extractFirstImageSrc = (html) => {
    try {
      const m = String(html || "").match(/<img[^>]+src=["']([^"']+)["']/i);
      return m ? m[1] : null;
    } catch {
      return null;
    }
  };

  // Detecta rutas locales no accesibles por el servidor (file://, C:\\, \\\\host\\)
  const isLocalPathUrl = (u) => {
    if (!u) return false;
    const s = String(u).trim();
    // Casos soportados:
    // - file://...
    // - C:\\... (backslash)
    // - C:/... (forward slash)
    // - \\\\host\\share (UNC)
    return (
      /^file:/i.test(s) ||
      /^[a-zA-Z]:[\\/]/.test(s) ||
      /^\\\\\\\\/.test(s)
    );
  };

  // Inyecta una etiqueta <img src="..."> al inicio si no hay imagen válida
  const withInjectedImage = (html, url) => {
    try {
      if (!url) return html;
      const current = extractFirstImageSrc(html);
      // Si ya hay imagen y no es ruta local, mantener
      if (current && !isLocalPathUrl(current)) return html;
      const safe = String(html || "");
      const tag = `<p><img src="${url}" alt="" /></p>`;
      return tag + safe;
    } catch {
      return html;
    }
  };

  const openPreview = async () => {
    // Validaciones: al menos 4 plantillas y lista seleccionada
    const countSel = [
      plantilla1,
      plantilla2,
      plantilla3,
      plantilla4,
      plantilla5,
    ].filter(Boolean).length;
    if (countSel < 4) {
      showToast("Debes seleccionar al menos 4 plantillas para continuar", "warning");
      return;
    }
    // Requerir campaña seleccionada (guardada) antes de continuar
    if (!campanaSeleccionada) {
      showToast(
        "Debes seleccionar una campaña guardada antes de continuar. Guarda la campaña o elige una existente.",
        "warning",
        5000
      );
      return;
    }
    const listId = String(listaClientes || "").trim();
    if (!listId) {
      showToast("Selecciona una lista de clientes", "warning");
      return;
    }
    try {
      // Obtener ids de contactos de la lista
      const { data: l } = await api.get(`listas/${listId}/`);
      const ids = Array.isArray(l?.contacts) ? l.contacts : [];
      if (ids.length === 0) {
        showToast("La lista seleccionada no tiene contactos", "warning");
        return;
      }
      // Obtener todos los contactos y filtrar por ids de la lista
      const { data: allC } = await api.get("contactos/");
      // Construir mapa robusto por id numérico y string para evitar fallos por tipo en llaves
      const map = new Map();
      (Array.isArray(allC) ? allC : []).forEach((c) => {
        try {
          map.set(c.id, c);
          map.set(String(c.id), c);
        } catch (_) {}
      });
      const recs = ids
        .map((id) => map.get(id) || map.get(String(id)) || map.get(Number(id)))
        .filter(Boolean);
      if (recs.length === 0) {
        showToast("No se encontraron contactos para la lista", "warning");
        return;
      }
      setRecipients(recs);
      // Validar fecha/hora si es programado (permitir ver el popup siempre)
      if (!sendNow) {
        const dtStr = `${date} ${time}`.trim();
        const dt = new Date(dtStr.replace(/-/g, "/"));
        if (!(dt instanceof Date) || isNaN(dt.getTime())) {
          showToast("Fecha u hora inválidas", "warning");
          return;
        }
        if (dt.getTime() <= Date.now()) {
          showToast(
            "El tiempo programado no puede ser menor al tiempo y fecha actual",
            "warning",
            5000
          );
          return;
        }
        // Ya no bloqueamos la vista previa si no es el día programado; solo se habilita el botón "Programar y Enviar".
      }
      // Forzar reapertura del modal incluso si quedó en un estado previo
      // (evita casos donde React no lo re-renderiza por estar ya true)
      setPreviewOpen(false);
      setTimeout(() => setPreviewOpen(true), 0);
    } catch (e) {
      console.error("Error preparando vista previa", e);
      showToast("No se pudo preparar la vista previa", "error");
    }
  };

  // Subir imagen al backend y obtener URL pública
  const handleUploadImage = async (file) => {
    if (!file) return;
    try {
      setUploadingImage(true);
      const fd = new FormData();
      fd.append("image", file);
      const r = await api.post("uploads/images/", fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      const url = r?.data?.image || r?.data?.url || null;
      if (url) {
        setOverrideImageUrl(url);
        // Si no se ha elegido un slot destino, usar el primero seleccionado
        try {
          if (!overrideTargetSlot) {
            const es = getSelectedTemplateEntries();
            if (es && es.length > 0) setOverrideTargetSlot(es[0].slot);
          }
        } catch (_) {}
        showToast("Imagen subida. Se usará en esta corrida.", "success");
      } else {
        showToast("No se obtuvo URL de la imagen subida", "warning");
      }
    } catch (e) {
      showToast(e?.message || "No se pudo subir la imagen", "error");
    } finally {
      setUploadingImage(false);
    }
  };

  // Permite programar una campaña reutilizada sin abrir la vista previa
  // (manteniendo la regla de que el popup solo aparece el día programado)
  const programarSinPreview = async () => {
    const plantillasSel = getSelectedTemplates();
    if (plantillasSel.length < 4) {
      showToast("Selecciona al menos 4 plantillas", "warning");
      return;
    }
    if (!campanaSeleccionada) {
      showToast("Debes seleccionar una campaña guardada para poder programar.", "warning", 5000);
      return;
    }
    const listId = String(listaClientes || "").trim();
    if (!listId) {
      showToast("Selecciona una lista de clientes", "warning");
      return;
    }
    const dtStr = `${date} ${time}`.trim();
    const dt = new Date(dtStr.replace(/-/g, "/"));
    if (!(dt instanceof Date) || isNaN(dt.getTime()) || dt.getTime() <= Date.now()) {
      showToast("El tiempo programado no puede ser menor al tiempo y fecha actual", "warning", 5000);
      return;
    }
    try {
      // Construir recipients igual que en preview
      const { data: l } = await api.get(`listas/${listId}/`);
      const ids = Array.isArray(l?.contacts) ? l.contacts : [];
      if (ids.length === 0) {
        showToast("La lista seleccionada no tiene contactos", "warning");
        return;
      }
      const { data: allC } = await api.get("contactos/");
      const map = new Map();
      (Array.isArray(allC) ? allC : []).forEach((c) => {
        try {
          map.set(c.id, c);
          map.set(String(c.id), c);
        } catch (_) {}
      });
      const recs = ids
        .map((id) => map.get(id) || map.get(String(id)) || map.get(Number(id)))
        .filter(Boolean);
      if (recs.length === 0) {
        showToast("No se encontraron contactos para la lista", "warning");
        return;
      }
      // Programar localmente y persistir en backend (fecha + grupo)
      scheduleJob({
        at: dt,
        recipients: recs,
        templates: plantillasSel,
        campaign: String(campanaSeleccionada),
      });
      try {
        const fechaStr = `${date} ${time}`;
        await api.patch(`campanas/${campanaSeleccionada}/`, {
          fecha: fechaStr,
          clientes: listId,
        });
      } catch (_) {}
      showToast("Envío programado", "success");
    } catch (e) {
      console.error("Error al programar sin preview", e);
      showToast(e?.message || "No se pudo programar", "error");
    }
  };

  useEffect(() => {
    return () => {
      if (sendTimerRef.current) {
        clearTimeout(sendTimerRef.current);
        sendTimerRef.current = null;
      }
    };
  }, []);

  // Sincronizar estado local de preview con estado global del manager para mostrar progreso
  useEffect(() => {
    if (!job || (job.status !== "scheduled" && job.status !== "sending")) {
      setSending(false);
      return;
    }
    setSendProgress({
      total: job.total || 0,
      current: job.current || 0,
      sent: job.sent || 0,
      failed: job.failed || 0,
    });
    setSending(job.status === "sending");
  }, [job]);

  // Detectar fin del envío local y limpiar para permitir nuevo envío sin refrescar
  useEffect(() => {
    if (job && (job.status === "done" || job.status === "stopped")) {
      // Liberar flag de envío y permitir reabrir preview
      setSending(false);
      setSendProgress({ total: 0, current: 0, sent: 0, failed: 0 });
    }
  }, [job?.status]);

  // Detectar fin del batch desatendido y limpiar botón/banderas
  useEffect(() => {
    if (batch && (batch.status === "done" || batch.status === "cancelled")) {
      // El provider ya borra batch cuando acaba; aquí liberamos UI local
      setSending(false);
    }
  }, [batch?.status]);

  // sendOne eliminado: se usa el gestor global

  const startSending = async () => {
    const plantillasSel = getSelectedTemplates();
    if (plantillasSel.length < 4) {
      showToast("Selecciona al menos 4 plantillas", "warning");
      return;
    }
    if (recipients.length === 0) return;
    try {
      // Requerir campaña seleccionada de forma obligatoria
      const campaignId = campanaSeleccionada ? String(campanaSeleccionada) : null;
      if (!campaignId) {
        showToast("Debes seleccionar una campaña guardada para poder enviar.", "warning", 5000);
        return;
      }
      // intervalMs ya no se usa directamente (el gestor genera aleatorio 7-20s)
      // Asegurar que el modal de preview permanezca visible durante el envío
      setPreviewOpen(true);
      // Aviso si hay rutas locales en imágenes pero no se adjuntó una imagen pública
      try {
        const hasLocalImg = plantillasSel.some((t) => {
          const img = extractFirstImageSrc(t?.content);
          return img && isLocalPathUrl(img);
        });
        if (hasLocalImg && !overrideImageUrl) {
          showToast(
            'Esta campaña tiene imágenes con rutas locales. Reemplaza esas rutas por URLs públicas antes de enviar.',
            "warning",
            5000
          );
        }
      } catch (_) {}
      // Si el usuario subió una imagen, inyectarla solo en la plantilla destino seleccionada,
      // siempre que no tenga video y no tenga ya una URL de imagen válida
      const entries = getSelectedTemplateEntries();
      const effectiveTemplates = entries.map((e) => {
        const t = e.data;
        if (!t) return t;
        if (!overrideImageUrl || !overrideTargetSlot || e.slot !== overrideTargetSlot) return t;
        const hasVideo = /<video[^>]+src=|<a[^>]+href=["']([^"']+\.(mp4|mov|webm|m4v))(\?|#|\"|')/i.test(
          String(t.content || "")
        );
        if (hasVideo) return t;
        const img = extractFirstImageSrc(t.content);
        if (img && !isLocalPathUrl(img)) return t;
        return { ...t, content: withInjectedImage(t.content, overrideImageUrl) };
      });
      startJob({ recipients, templates: effectiveTemplates, campaign: campaignId, startIndex: 0 });
      setSending(true);
    } catch (e) {
      showToast(e?.message || "No se pudo iniciar el envío", "error");
    }
  };

  const startServerSending = async () => {
    const plantillasSel = getSelectedTemplates();
    if (plantillasSel.length < 4) {
      showToast("Selecciona al menos 4 plantillas", "warning");
      return;
    }
    if (recipients.length === 0) return;
    if (!campanaSeleccionada) {
      showToast("Debes seleccionar una campaña guardada", "warning");
      return;
    }
    try {
      // Aplicar la misma lógica de inyección: sólo a la plantilla destino
      const entries = getSelectedTemplateEntries();
      const effectiveTemplates = entries.map((e) => {
        const t = e.data;
        if (!t) return t;
        if (!overrideImageUrl || !overrideTargetSlot || e.slot !== overrideTargetSlot) return t;
        const hasVideo = /<video[^>]+src=|<a[^>]+href=["']([^"']+\.(mp4|mov|webm|m4v))(\?|#|\"|')/i.test(
          String(t.content || "")
        );
        if (hasVideo) return t;
        const img = extractFirstImageSrc(t.content);
        if (img && !isLocalPathUrl(img)) return t;
        return { ...t, content: withInjectedImage(t.content, overrideImageUrl) };
      });
      await startServerBatch({ recipients, templates: effectiveTemplates, campaign: String(campanaSeleccionada) });
      showToast("Envío desatendido iniciado", "success");
      setSending(true);
    } catch (e) {
      showToast(e?.message || "No se pudo iniciar en servidor", "error", 5000);
    }
  };

  // Aviso si el batch se detiene inesperadamente para revisar conexión de WhatsApp
  const lastBatchStatusRef = useRef(null);
  useEffect(() => {
    const st = batch?.status;
    const prev = lastBatchStatusRef.current;
    if (st) lastBatchStatusRef.current = st;
    // Si antes estaba running y ahora terminó con error o sin avanzar
    if (prev === "running" && st && st !== "running" && st !== "completed") {
      showToast("Revisa tu conexión de WhatsApp (envío desatendido detenido)", "warning", 6000);
    }
    // Si desapareció batch mientras estaba running
    if (prev === "running" && !batch) {
      showToast("Revisa tu conexión de WhatsApp (envío desatendido interrumpido)", "warning", 6000);
    }
  }, [batch]);

  // -------------------------
  // Renderizado
  // -------------------------

  // Listado principal de campañas
  if (view === "index") {
    return (
      <div
        className="dashboard-layout"
        style={{
          background: dark ? "#0b1220" : "#fff",
          minHeight: "100vh",
          transition: "background 0.25s ease",
        }}
      >
        <Sidebar />
        <main
          className="dashboard-main"
          style={{
            background: dark ? "#0b1220" : "#fff",
            color: dark ? "#e6eef8" : "#0b1220",
            minHeight: "100vh",
            padding: 24,
          }}
        >
          {/* === HEADER MEJORADO (ESTRUCTURA ESTANDARIZADA) === */}
          <div
            style={{
              background: dark ? "#0f172a" : "#ffffff",
              borderRadius: 16,
              padding: "24px 28px",
              marginBottom: 24,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              boxShadow: dark
                ? "0 6px 18px rgba(10,13,20,0.6)"
                : "0 6px 18px rgba(12,36,80,0.06)",
              border: dark ? "1px solid #1f2937" : "1px solid #e6eef8",
            }}
          >
            {/* === LADO IZQUIERDO: Icono + Texto + Botones === */}
            <div style={{ display: "flex", alignItems: "flex-start", gap: 16 }}>
              {/* Ícono */}
              <div
                style={{
                  width: 64,
                  height: 64,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: 14,
                  background: dark
                    ? "linear-gradient(135deg,#0ea5e9,#7c3aed)"
                    : "linear-gradient(135deg,#34d399,#06b6d4)",
                  boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
                  color: "#fff",
                  fontSize: 28,
                }}
                aria-hidden
              >
                📣
              </div>

              {/* Texto + Botones */}
              <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                <div>
                  <div style={{ fontSize: 22, fontWeight: 700 }}>Campañas</div>
                  <div
                    style={{
                      fontSize: 13,
                      color: dark ? "#9fb0c8" : "#64748b",
                      marginTop: 4,
                    }}
                  >
                    Administra y programa tus campañas. Selecciona, revisa y envía.
                  </div>
                </div>

                {/* === BOTONES DE ACCIÓN ABAJO === */}
                <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
                  <button
                    onClick={() => setView("create")}
                    className={`px-4 py-2 rounded-xl text-sm font-semibold shadow-md transition-all transform active:scale-95
                      ${
                        dark
                          ? "bg-gradient-to-r from-emerald-500 to-cyan-500 text-gray-900 hover:from-emerald-400 hover:to-cyan-400"
                          : "bg-gradient-to-r from-emerald-500 to-cyan-600 text-white hover:from-emerald-600 hover:to-cyan-700"
                      }`}
                    style={{
                      border: "none",
                      cursor: "pointer",
                    }}
                  >
                    + Crear campaña
                  </button>

                  <button
                    onClick={() => navigate("/calendario")}
                    className={`px-4 py-2 rounded-xl text-sm font-semibold shadow-md transition-all transform active:scale-95
                      bg-gradient-to-r from-indigo-500 to-purple-600 text-white hover:from-indigo-600 hover:to-purple-700`}
                    style={{
                      border: "none",
                      cursor: "pointer",
                    }}
                  >
                    📅 Programar campañas
                  </button>
                </div>
              </div>
            </div>

            {/* === LADO DERECHO: Toggle tema + UserMenu === */}
            <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
              <button
                onClick={() => setDark(!dark)}
                title={dark ? "Cambiar a tema claro" : "Cambiar a tema oscuro"}
                className={`px-4 py-2 rounded-xl text-sm font-medium shadow-md transition-transform active:scale-95
                  ${
                    dark
                      ? "bg-gradient-to-r from-yellow-400 to-yellow-500 text-gray-900 hover:from-yellow-500 hover:to-yellow-600"
                      : "bg-gradient-to-r from-indigo-500 to-purple-600 text-white hover:from-indigo-600 hover:to-purple-700"
                  }`}
              >
                {dark ? "☀ Claro" : "🌙 Oscuro"}
              </button>

              <UserMenu usernameProp={localStorage.getItem("username")} />
            </div>
          </div>

          {/* === ENCABEZADO ANTES DE TABLA ===  BORRAR SI NO LES GUSTA :D*/}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: "1rem",
              padding: "0 0.5rem",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
                fontSize: "1.25rem",
                fontWeight: "700",
                color: dark ? "#f8fafc" : "#0f172a",
              }}
            >
              📊 Resumen de campañas
            </div>

            {summary.length > 0 && (
              <div
                style={{
                  fontSize: "0.95rem",
                  color: dark ? "#94a3b8" : "#475569",
                  background: dark ? "#1e293b" : "#f1f5f9",
                  borderRadius: 10,
                  padding: "6px 12px",
                }}
              >
                Total: <b>{summary.length}</b> campañas registradas
              </div>
            )}
          </div>
          <section
          
            style={{
              background: dark ? "#071029" : "#fff",
              borderRadius: 18,
              boxShadow: dark
                ? "0 8px 30px rgba(2,6,23,0.6)"
                : "0 2px 12px rgba(44,62,80,0.12)",
              padding: "1.5rem",
              maxWidth: "100%",
              margin: "1rem auto",
              border: dark ? "1px solid #0f172a" : "1px solid #e6eef8",
              transition: "background 0.25s ease, color 0.25s ease",
              width: "100%",
            }}
          >
            {summaryLoading ? (
              <div
                style={{
                  padding: "0.75rem",
                  color: dark ? "#9fb0c8" : "#64748b",
                  textAlign: "center",
                  fontSize: "1rem",
                }}
              >
                Cargando campañas…
              </div>
            ) : (
              <div style={{ overflowX: "auto" }}>
                <table
                  style={{
                    width: "100%",
                    borderCollapse: "separate",
                    borderSpacing: 0,
                    minWidth: 600,
                  }}
                >
                  <thead>
                    <tr
                      style={{
                        background: dark ? "#0b1220" : "#f8fafc",
                        color: dark ? "#cbd5e1" : "#334155",
                        textAlign: "left",
                        fontWeight: "600",
                        fontSize: "0.95rem",
                        borderBottom: dark
                          ? "1px solid rgba(148,163,184,0.2)"
                          : "1px solid #e2e8f0",
                      }}
                    >
                      <th style={{ padding: "0.9rem 1rem", borderTopLeftRadius: 10 }}>
                        Nombre campaña
                      </th>
                      <th style={{ padding: "0.9rem 1rem" }}>Nombre vista asociada</th>
                      <th style={{ padding: "0.9rem 1rem" }}>Alcance</th>
                      <th style={{ padding: "0.9rem 1rem" }}>Fecha</th>
                      <th
                        style={{ padding: "0.9rem 1rem", borderTopRightRadius: 10 }}
                      >
                        Estado
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {summary.length === 0 ? (
                      <tr>
                        <td
                          colSpan={5}
                          style={{
                            padding: "1rem",
                            textAlign: "center",
                            color: dark ? "#8fa7bf" : "#64748b",
                            fontSize: "0.95rem",
                            background: dark ? "#0b1220" : "#f8fafc",
                            borderRadius: "0 0 10px 10px",
                          }}
                        >
                          No tienes campañas aún. Crea tu primera campaña.
                        </td>
                      </tr>
                    ) : (
                      summary.map((c, index) => (
                        <tr
                          key={c.id}
                          style={{
                            background:
                              index % 2 === 0
                                ? dark
                                  ? "#0b1220"
                                  : "#f8fafc"
                                : dark
                                ? "#071029"
                                : "#fff",
                            transition: "background 0.2s ease",
                          }}
                          onMouseEnter={(e) =>
                            (e.currentTarget.style.background = dark
                              ? "#11263a"
                              : "#f1f5f9")
                          }
                          onMouseLeave={(e) =>
                            (e.currentTarget.style.background =
                              index % 2 === 0
                                ? dark
                                  ? "#0b1220"
                                  : "#f8fafc"
                                : dark
                                ? "#071029"
                                : "#fff")
                          }
                        >
                          <td
                            style={{
                              padding: "0.85rem 1rem",
                              color: dark ? "#e2e8f0" : "#1e293b",
                              fontWeight: 500,
                            }}
                          >
                            {c.nombre}
                          </td>
                          <td style={{ padding: "0.85rem 1rem" }}>
                            <button
                              onClick={() => openCampaignDetails(c.id)}
                              style={{
                                background: "transparent",
                                color: dark ? "#38bdf8" : "#0b5ed7",
                                border: "none",
                                textDecoration: "underline",
                                cursor: "pointer",
                                fontSize: "0.9rem",
                              }}
                              title="Ver destinatarios de envíos de esta campaña"
                            >
                              {c.vista_nombre || "-"}
                            </button>
                          </td>
                          <td
                            style={{
                              padding: "0.85rem 1rem",
                              color: dark ? "#cbd5e1" : "#475569",
                            }}
                          >
                            {c.alcance || 0}
                          </td>
                          <td
                            style={{
                              padding: "0.85rem 1rem",
                              color: dark ? "#cbd5e1" : "#475569",
                            }}
                          >
                            {c.fecha}
                          </td>
                          <td
                            style={{
                              padding: "0.85rem 1rem",
                              color:
                                 c.estado === "Activa" || c.estado === "Completada"
                              ? "#16a34a" // verde
                              : c.estado === "Pausada"
                              ? "#eab308" // amarillo
                              : "#ef4444", // rojo (Cancelada u otro)
                              fontWeight: 600,
                            }}
                          >
                            {c.estado}
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            )}
          </section>

        </main>

        {detailOpen && (
          <div
            style={{
              position: "fixed",
              inset: 0,
              background: "rgba(0,0,0,0.45)",
              zIndex: 1000,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: 16,
            }}
          >
            <div
              style={{
                width: "min(1000px,96vw)",
                maxHeight: "92vh",
                background: dark ? "#041024" : "#ffffff",
                color: dark ? "#e6eef8" : "#0b1220",
                borderRadius: 12,
                boxShadow: dark ? "0 12px 30px rgba(0,0,0,0.6)" : "0 12px 30px rgba(0,0,0,0.25)",
                display: "flex",
                flexDirection: "column",
                border: dark ? "1px solid #142032" : "1px solid #e5e7eb",
              }}
            >
              <div
                style={{
                  padding: 14,
                  borderBottom: dark ? "1px solid #142032" : "1px solid #e5e7eb",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ fontWeight: 700 }}>
                  Envíos de campaña {detailCampaign?.nombre || ""}{" "}
                  {detailCampaign?.lista_nombre ? `(lista: ${detailCampaign.lista_nombre})` : ""}
                </div>
                <button
                  onClick={() => setDetailOpen(false)}
                  style={{ background: "transparent", border: "none", fontSize: 18, cursor: "pointer", color: dark ? "#9fb0c8" : "#0b1220" }}
                  aria-label="Cerrar"
                >
                  ✕
                </button>
              </div>

              <div style={{ display: "flex", gap: 12, padding: 12, overflow: "hidden" }}>
                <div style={{ width: 260, minWidth: 200, borderRight: dark ? "1px solid #142032" : "1px solid #e5e7eb", paddingRight: 12, overflowY: "auto", maxHeight: "70vh" }}>
                  {/* Filtro por fecha (único) */}
                  <div style={{ paddingBottom: 8, borderBottom: dark ? "1px solid #142032" : "1px solid #e5e7eb", marginBottom: 8 }}>
                    <div style={{ fontSize: 12, color: dark ? "#9fb0c8" : "#475569", marginBottom: 6 }}>Filtrar corridas por fecha</div>
                    <div>
                      <input
                        type="date"
                        value={detailRunFilterDate}
                        onChange={(e) => setDetailRunFilterDate(e.target.value)}
                        style={{ border: "1px solid #cbd5e1", borderRadius: 6, padding: "4px 6px", width: "100%" }}
                      />
                    </div>
                  </div>
                  {detailLoading ? (
                    <div style={{ padding: 8, color: dark ? "#9fb0c8" : "#64748b" }}>Cargando…</div>
                  ) : detailError ? (
                    <div style={{ padding: 8, color: "#dc2626" }}>{detailError}</div>
                  ) : filteredRuns.length === 0 ? (
                    <div style={{ padding: 8, color: dark ? "#9fb0c8" : "#64748b" }}>Sin envíos registrados aún</div>
                  ) : (
                    filteredRuns.map((r, idx) => (
                      <div
                        key={r.run_id || idx}
                        onClick={() => setDetailSelectedRun(idx)}
                        style={{
                          padding: "8px 10px",
                          borderRadius: 8,
                          marginBottom: 6,
                          cursor: "pointer",
                          background: idx === detailSelectedRun ? (dark ? "#082035" : "#e6f2fb") : (dark ? "#00121a" : "#fff"),
                          border: dark ? "1px solid #0b3449" : "1px solid #e5e7eb",
                        }}
                      >
                        <div style={{ fontWeight: 600, fontSize: 13, color: dark ? "#e6eef8" : "#0b1220" }}>{r.label || (r.run_id || "corrida")}</div>
                        <div style={{ fontSize: 12, color: dark ? "#9fb0c8" : "#64748b" }}>{r.started_at ? new Date(r.started_at).toLocaleString() : ""} – {r.ended_at ? new Date(r.ended_at).toLocaleString() : ""}</div>
                        <div style={{ fontSize: 12, color: dark ? "#e6eef8" : "#0b1220", marginTop: 2 }}>Enviados: {r.total || 0}</div>
                      </div>
                    ))
                  )}
                </div>

                <div style={{ flex: 1, overflow: "auto", maxHeight: "70vh" }}>
                  {filteredRuns[detailSelectedRun] ? (
                    <>
                      {/* Buscador de contactos */}
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
                        <input
                          type="text"
                          value={detailContactQuery}
                          onChange={(e) => setDetailContactQuery(e.target.value)}
                          placeholder="Buscar por nombre o teléfono"
                          style={{ border: "1px solid #cbd5e1", borderRadius: 6, padding: "6px 8px", width: 280 }}
                        />
                        <div style={{ fontSize: 12, color: dark ? "#9fb0c8" : "#64748b" }}>
                          Mostrando{" "}
                          {(() => {
                            const r = filteredRuns[detailSelectedRun];
                            const q = (detailContactQuery || "").toLowerCase().trim();
                            const total = Array.isArray(r.contacts) ? r.contacts.length : 0;
                            const vis = q ? (r.contacts || []).filter((ct) => (String(ct.full_name || "").toLowerCase().includes(q) || String(ct.phone || "").toLowerCase().includes(q))).length : total;
                            return `${vis}/${total}`;
                          })()}
                        </div>
                      </div>

                      <table style={{ width: "100%", borderCollapse: "collapse" }}>
                        <thead>
                          <tr style={{ textAlign: "left", color: dark ? "#9fb0c8" : "#475569" }}>
                            <th style={{ padding: "0.5rem", borderBottom: dark ? "1px solid #142032" : "1px solid #e2e8f0" }}>Nombre</th>
                            <th style={{ padding: "0.5rem", borderBottom: dark ? "1px solid #142032" : "1px solid #e2e8f0" }}>Teléfono</th>
                            <th style={{ padding: "0.5rem", borderBottom: dark ? "1px solid #142032" : "1px solid #e2e8f0" }}>Fecha envío</th>
                          </tr>
                        </thead>
                        <tbody>
                          {(filteredRuns[detailSelectedRun].contacts || [])
                            .filter((ct) => {
                              const q = (detailContactQuery || "").toLowerCase().trim();
                              if (!q) return true;
                              return String(ct.full_name || "").toLowerCase().includes(q) || String(ct.phone || "").toLowerCase().includes(q);
                            })
                            .map((ct, i) => (
                              <tr key={`${ct.id || ct.phone || i}-${i}`} style={{ borderTop: "1px solid #f1f5f9" }}>
                                <td style={{ padding: "0.5rem" }}>{ct.full_name || "-"}</td>
                                <td style={{ padding: "0.5rem" }}>{ct.phone || "-"}</td>
                                <td style={{ padding: "0.5rem" }}>{ct.sent_at ? new Date(ct.sent_at).toLocaleString() : "-"}</td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </>
                  ) : (
                    <div style={{ color: dark ? "#9fb0c8" : "#64748b" }}>Selecciona una corrida</div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  // Vista de creación (contenido actual)
  return (
    <div
      className="dashboard-layout"
      style={{
        background: dark ? "#071029" : "#fff",
        minHeight: "100vh",
        transition: "background 0.25s ease",
      }}
    >
      <Sidebar />
      <main
        className="dashboard-main"
        style={{
          background: dark ? "#071029" : "#fff",
          color: dark ? "#e6eef8" : "#0b1220",
          minHeight: "100vh",
          padding: 24,
        }}
      >
        {/* === HEADER UNIFICADO / CONSISTENTE === */}
        <div
          style={{
            background: dark ? "#0f172a" : "#ffffff",
            borderRadius: 16,
            padding: "24px 28px",
            marginBottom: 24,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            boxShadow: dark
              ? "0 6px 18px rgba(10,13,20,0.6)"
              : "0 6px 18px rgba(12,36,80,0.06)",
            border: dark ? "1px solid #1f2937" : "1px solid #e6eef8",
          }}
        >
          {/* === IZQUIERDA === */}
          <div style={{ display: "flex", alignItems: "flex-start", gap: 16 }}>
            {/* Ícono */}
            <div
              style={{
                width: 64,
                height: 64,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: 14,
                background: dark
                  ? "linear-gradient(135deg,#0ea5e9,#7c3aed)"
                  : "linear-gradient(135deg,#34d399,#06b6d4)",
                boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
                color: "#fff",
                fontSize: 28,
              }}
            >
              🧩
            </div>

            {/* Texto + Botones */}
            <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
              <div>
                <div style={{ fontSize: 22, fontWeight: 700 }}>Crear una nueva campaña</div>
                <div
                  style={{
                    fontSize: 13,
                    color: dark ? "#9fb0c8" : "#64748b",
                    marginTop: 4,
                  }}
                >
                  Configura plantillas, listas y horarios de envío.
                </div>
              </div>

              <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
                <button
                  onClick={() => setView("index")}
                  className={`px-4 py-2 rounded-xl text-sm font-semibold shadow-md transition-all transform active:scale-95
                    ${
                      dark
                        ? "bg-gradient-to-r from-slate-600 to-slate-700 text-gray-100 hover:from-slate-500 hover:to-slate-600"
                        : "bg-gradient-to-r from-slate-100 to-slate-200 text-gray-900 hover:from-slate-200 hover:to-slate-300"
                    }`}
                  style={{
                    border: "none",
                    cursor: "pointer",
                  }}
                >
                  ← Volver al listado
                </button>

                <button
                  onClick={() => navigate("/calendario")}
                  className={`px-4 py-2 rounded-xl text-sm font-semibold shadow-md transition-all transform active:scale-95
                    bg-gradient-to-r from-indigo-500 to-purple-600 text-white hover:from-indigo-600 hover:to-purple-700`}
                  style={{
                    border: "none",
                    cursor: "pointer",
                  }}
                >
                  📅 Programar campañas
                </button>
              </div>
            </div>
          </div>

          {/* === DERECHA === */}
          <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
            <button
              onClick={() => setDark(!dark)}
              title={dark ? "Cambiar a tema claro" : "Cambiar a tema oscuro"}
              className={`px-4 py-2 rounded-xl text-sm font-medium shadow-md transition-transform active:scale-95
                ${
                  dark
                    ? "bg-gradient-to-r from-yellow-400 to-yellow-500 text-gray-900 hover:from-yellow-500 hover:to-yellow-600"
                    : "bg-gradient-to-r from-indigo-500 to-purple-600 text-white hover:from-indigo-600 hover:to-purple-700"
                }`}
            >
              {dark ? "☀ Claro" : "🌙 Oscuro"}
            </button>

            <UserMenu usernameProp={localStorage.getItem("username")} />
          </div>
        </div>

    {/* === Contenido principal de la creación (diseño mejorado, ocupa todo el ancho) === */}
  <section
    style={{
      background: dark ? "#071029" : "#ffffff",
      borderRadius: 20,
      boxShadow: dark
        ? "0 12px 40px rgba(2,6,23,0.7)"
        : "0 10px 30px rgba(16,24,40,0.06)",
      padding: "2.4rem 2.6rem",
      width: "100%",        // ocupar todo el ancho disponible
      maxWidth: "100%",     // no limitar a 720px
      margin: "0 0 2rem 0", // mantener separación inferior
      border: dark ? "1px solid rgba(255,255,255,0.03)" : "1px solid #e6eef8",
      transition: "all 0.25s ease-in-out",
      color: dark ? "#e6eef8" : "#0f172a",
    }}
  >
    {/* === NOMBRE CAMPAÑA === */}
    <div style={{ marginBottom: 28 }}>
      <label
        style={{
          fontWeight: 600,
          fontSize: "1.05rem",
          color: dark ? "#e2e8f0" : "#1e293b",
        }}
      >
        Nombre de campaña
      </label>
      <input
        type="text"
        value={nombreCampana}
        onChange={(e) => setNombreCampana(e.target.value)}
        placeholder="Escribe el nombre de la campaña"
        style={{
          width: "100%",
          marginTop: 10,
          padding: "0.75rem 1rem",
          borderRadius: 12,
          border: dark ? "1px solid #23303c" : "1px solid #e6eef8",
          background: dark ? "#071a26" : "#f8fafc",
          color: dark ? "#f1f5f9" : "#0f172a",
          fontSize: "0.95rem",
          outline: "none",
          boxShadow: dark ? "inset 0 1px 0 rgba(255,255,255,0.02)" : "0 2px 6px rgba(16,24,40,0.03)",
          transition: "box-shadow .18s ease, transform .12s ease",
        }}
      />
    </div>

    {/* === CAMPAÑAS GUARDADAS === */}
    <div style={{ marginBottom: 28, position: "relative" }}>
      <label
        style={{
          fontWeight: 600,
          fontSize: "1.05rem",
          color: dark ? "#e2e8f0" : "#1e293b",
        }}
      >
        Selecciona campaña guardada
      </label>

      {/* Selector principal */}
      <div
        onClick={() => setShowCampanasMenu((v) => !v)}
        style={{
          marginTop: 10,
          background: dark ? "linear-gradient(180deg,#071722,#081827)" : "#ffffff",
          border: dark ? "1px solid #23303c" : "1px solid #e6eef8",
          borderRadius: 12,
          padding: "0.75rem 1rem",
          fontSize: "0.95rem",
          cursor: "pointer",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          color: dark ? "#e6eef8" : "#0f172a",
          transition: "transform .12s ease, box-shadow .12s ease",
          boxShadow: dark ? "0 6px 16px rgba(2,8,18,0.45)" : "0 2px 8px rgba(16,24,40,0.04)",
        }}
      >
        <span
          style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            fontWeight: 500,
            maxWidth: "80%",
          }}
        >
          {campanaSeleccionada
            ? campanasGuardadas.find(
                (c) => String(c.id) === String(campanaSeleccionada)
              )?.nombre || "(no encontrada)"
            : "— Selecciona una campaña —"}
        </span>
        <span style={{ fontSize: 14, opacity: 0.8 }}>
          {showCampanasMenu ? "▲" : "▼"}
        </span>
      </div>

      {showCampanasMenu && (
        <div
          style={{
            position: "absolute",
            top: "4.6rem",
            left: 0,
            right: 0,
            background: dark ? "#071022" : "#ffffff",
            border: dark ? "1px solid #23303c" : "1px solid #e6eef8",
            borderRadius: 12,
            zIndex: 50,
            maxHeight: 320,
            overflowY: "auto",
            boxShadow: dark
              ? "0 20px 40px rgba(2,6,23,0.7)"
              : "0 12px 30px rgba(16,24,40,0.08)",
            paddingBottom: 6,
          }}
        >
          {campanasGuardadas.length === 0 && (
            <div
              style={{
                padding: "0.75rem 1rem",
                fontSize: "0.95rem",
                color: dark ? "#9ca3af" : "#64748b",
                background: "transparent",
              }}
            >
              No hay campañas guardadas
            </div>
          )}

          {campanasGuardadas.map((c) => (
            <div
              key={c.id}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: 8,
                padding: "0.6rem 1rem",
                cursor: "pointer",
                background:
                  String(c.id) === String(campanaSeleccionada)
                    ? dark
                      ? "#0e2a3a"
                      : "#e6f9ff"
                    : "transparent",
                transition: "background .15s ease",
              }}
              onClick={() => {
                setCampanaSeleccionada(String(c.id));
                setShowCampanasMenu(false);
              }}
            >
              <span
                style={{
                  flex: 1,
                  fontSize: "0.95rem",
                  color: dark ? "#e2e8f0" : "#0f172a",
                  fontWeight: 500,
                }}
              >
                {c.nombre}
              </span>

              <button
                onClick={(e) => {
                  e.stopPropagation();
                  if (confirm("¿Eliminar campaña?")) {
                    eliminarCampana(c.id);
                    if (String(c.id) === String(campanaSeleccionada))
                      setCampanaSeleccionada("");
                  }
                }}
                style={{
                  background: "#dc2626",
                  color: "#fff",
                  border: "none",
                  borderRadius: 8,
                  padding: "0.35rem 0.65rem",
                  fontSize: "0.78rem",
                  cursor: "pointer",
                  fontWeight: 700,
                  transition: "transform .12s ease",
                }}
                title="Eliminar campaña"
              >
                Eliminar
              </button>
            </div>
          ))}
        </div>
      )}

      {loading && (
        <div style={{ marginTop: "0.6rem", fontSize: "0.9rem", opacity: 0.85 }}>
          Cargando campañas...
        </div>
      )}

      {campanasError && (
        <div
          style={{
            marginTop: "0.6rem",
            fontSize: "0.9rem",
            color: "#ffc107",
          }}
        >
          {campanasError} (mostrando cache local si existe)
        </div>
      )}
    </div>

    {/* === Selector de listas === */}
    <div style={{ marginBottom: "1.5rem" }}>
      <label style={{ fontWeight: "600", fontSize: "1.05rem", color: dark ? "#e2e8f0" : "#1e293b" }}>
        Listas de clientes
      </label>
      <select
        value={listaClientes}
        onChange={(e) => setListaClientes(e.target.value)}
        style={{
          width: "100%",
          padding: "0.65rem 0.9rem",
          borderRadius: 10,
          border: dark ? "1px solid #23303c" : "1px solid #e6eef8",
          marginTop: 10,
          fontSize: "1rem",
          background: dark ? "#071a26" : "#ffffff",
          color: dark ? "#e6eef8" : "#0f172a",
          outline: "none",
          boxShadow: dark ? "inset 0 1px 0 rgba(255,255,255,0.02)" : "0 2px 6px rgba(16,24,40,0.03)",
        }}
      >
        <option value="">-- Selecciona una lista --</option>
        {listasDisponibles.map((l) => (
          <option key={l.id} value={String(l.id)}>
            {l.name}
          </option>
        ))}
      </select>

      {listasDisponibles.length === 0 && (
        <div style={{ marginTop: "0.5rem", fontSize: "0.9rem", opacity: 0.85 }}>
          No tienes listas aún. Crea una en la sección Contactos.
        </div>
      )}
    </div>

    {/* === Selección de plantillas === */}
    <div style={{ marginBottom: "1.5rem" }}>
      <label style={{ fontWeight: 600, fontSize: "1.05rem", color: dark ? "#e2e8f0" : "#1e293b" }}>
        Selecciona al menos 4 plantillas para crear tu campaña
      </label>

      <div style={{ marginTop: 10, display: "flex", flexDirection: "column", gap: 10 }}>
        {[1, 2, 3, 4, 5].map((num) => (
          <div key={num} style={{ position: "relative" }}>
            <button
              style={{
                background: dark ? "#071a26" : "#ffffff",
                color: dark ? "#e6eef8" : "#0b1220",
                border: dark ? "1px solid #23303c" : "1px solid #e6eef8",
                borderRadius: 10,
                padding: "0.5rem 0.9rem",
                fontSize: "0.95rem",
                cursor: "pointer",
                width: "100%",
                textAlign: "left",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                boxShadow: dark ? "0 6px 18px rgba(2,8,18,0.35)" : "0 3px 8px rgba(16,24,40,0.04)",
              }}
              onClick={() => {
                if (num === 1) setShowPlantillasMenu1(!showPlantillasMenu1);
                if (num === 2) setShowPlantillasMenu2(!showPlantillasMenu2);
                if (num === 3) setShowPlantillasMenu3(!showPlantillasMenu3);
                if (num === 4) setShowPlantillasMenu4(!showPlantillasMenu4);
                if (num === 5) setShowPlantillasMenu5(!showPlantillasMenu5);
              }}
            >
              <span style={{ flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", fontWeight: 500 }}>
                {(() => {
                  if (num === 1)
                    return plantilla1
                      ? obtenerNombrePlantilla(plantilla1) || `Plantilla #${plantilla1}`
                      : "Seleccione una plantilla";
                  if (num === 2)
                    return plantilla2
                      ? obtenerNombrePlantilla(plantilla2) || `Plantilla #${plantilla2}`
                      : "Seleccione una plantilla";
                  if (num === 3)
                    return plantilla3
                      ? obtenerNombrePlantilla(plantilla3) || `Plantilla #${plantilla3}`
                      : "Seleccione una plantilla";
                  if (num === 4)
                    return plantilla4
                      ? obtenerNombrePlantilla(plantilla4) || `Plantilla #${plantilla4}`
                      : "Seleccione una plantilla";
                  if (num === 5)
                    return plantilla5
                      ? obtenerNombrePlantilla(plantilla5) || `Plantilla #${plantilla5}`
                      : "Seleccione una plantilla";
                  return null;
                })()}
              </span>
              <span style={{ opacity: 0.7, marginLeft: 12 }}>{(num === 1 && showPlantillasMenu1) || (num === 2 && showPlantillasMenu2) || (num === 3 && showPlantillasMenu3) || (num === 4 && showPlantillasMenu4) || (num === 5 && showPlantillasMenu5) ? "▲" : "▼"}</span>
            </button>

            {((num === 1 && showPlantillasMenu1) ||
              (num === 2 && showPlantillasMenu2) ||
              (num === 3 && showPlantillasMenu3) ||
              (num === 4 && showPlantillasMenu4) ||
              (num === 5 && showPlantillasMenu5)) && (
              <div
                style={{
                  position: "absolute",
                  top: "3.6rem",
                  left: 0,
                  background: dark ? "#071a26" : "#ffffff",
                  border: dark ? "1px solid #23303c" : "1px solid #e6eef8",
                  borderRadius: 10,
                  minWidth: "220px",
                  zIndex: 10,
                  maxHeight: 260,
                  overflowY: "auto",
                  boxShadow: dark ? "0 14px 30px rgba(2,8,18,0.55)" : "0 12px 30px rgba(16,24,40,0.07)",
                }}
              >
                <div
                  style={{
                    padding: "0.5rem 0.75rem",
                    cursor: "pointer",
                    borderBottom: "1px solid rgba(0,0,0,0.04)",
                    color: dark ? "#9ca3af" : "#64748b",
                    fontStyle: "italic",
                    fontSize: "0.9rem",
                  }}
                  onClick={() => {
                    if (num === 1) {
                      setPlantilla1("");
                      setShowPlantillasMenu1(false);
                    }
                    if (num === 2) {
                      setPlantilla2("");
                      setShowPlantillasMenu2(false);
                    }
                    if (num === 3) {
                      setPlantilla3("");
                      setShowPlantillasMenu3(false);
                    }
                    if (num === 4) {
                      setPlantilla4("");
                      setShowPlantillasMenu4(false);
                    }
                    if (num === 5) {
                      setPlantilla5("");
                      setShowPlantillasMenu5(false);
                    }
                  }}
                >
                  — No seleccionar —
                </div>

                {plantillasDisponibles.length === 0 && (
                  <div style={{ padding: "0.6rem 0.75rem", fontSize: "0.9rem", opacity: 0.85 }}>
                    No hay plantillas creadas todavía
                  </div>
                )}

                {plantillasDisponibles.map((p) => (
                  <div
                    key={p.id}
                    style={{
                      padding: "0.55rem 0.75rem",
                      cursor: "pointer",
                      borderBottom: "1px solid rgba(0,0,0,0.04)",
                    }}
                    onClick={() => {
                      if (num === 1) {
                        setPlantilla1(p.id);
                        setShowPlantillasMenu1(false);
                      }
                      if (num === 2) {
                        setPlantilla2(p.id);
                        setShowPlantillasMenu2(false);
                      }
                      if (num === 3) {
                        setPlantilla3(p.id);
                        setShowPlantillasMenu3(false);
                      }
                      if (num === 4) {
                        setPlantilla4(p.id);
                        setShowPlantillasMenu4(false);
                      }
                      if (num === 5) {
                        setPlantilla5(p.id);
                        setShowPlantillasMenu5(false);
                      }
                    }}
                  >
                    <strong style={{ display: "block", fontSize: "0.9rem", color: dark ? "#e6eef8" : "#0f172a" }}>
                      {p.title}
                    </strong>
                    <span style={{ fontSize: "0.8rem", opacity: 0.75, color: dark ? "#9ca3af" : "#475569" }}>
                      {(p.content || "").replace(/<(.|\n)*?>/g, "").slice(0, 90)}
                      {p.content && p.content.length > 90 ? "…" : ""}
                    </span>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Botón guardar campaña (ancho completo) */}
      <div style={{ marginTop: 16 }}>
        <button
          style={{
            background: isSaving ? "#1f7fab" : "#28a7e0",
            color: "#fff",
            borderRadius: 12,
            border: "none",
            padding: "0.85rem 1.2rem",
            fontWeight: 700,
            cursor: isSaving ? "not-allowed" : "pointer",
            width: "100%",
            opacity: isSaving ? 0.85 : 1,
            boxShadow: dark ? "0 8px 30px rgba(2,8,18,0.45)" : "0 8px 30px rgba(16,24,40,0.08)",
            transition: "transform .12s ease, box-shadow .12s ease",
          }}
          onClick={guardarCampana}
          disabled={isSaving}
        >
          {isSaving ? "Guardando…" : "Guardar campaña"}
        </button>
      </div>
    </div>

    <div style={{ marginBottom: "2rem" }}>
      <label style={{ fontWeight: 600, fontSize: "1.05rem", color: dark ? "#e2e8f0" : "#1e293b" }}>
        Schedule & Send
      </label>

      <div style={{ display: "flex", alignItems: "center", gap: "1.2rem", marginTop: "0.75rem", flexWrap: "wrap" }}>
        <label style={{ display: "flex", alignItems: "center", gap: "0.6rem", fontSize: "0.95rem", color: dark ? "#e2e8f0" : "#0f172a" }}>
          <input type="checkbox" checked={sendNow} onChange={() => setSendNow(!sendNow)} />
          Enviar inmediatamente
        </label>

        <div style={{ display: sendNow ? "none" : "flex", gap: "0.6rem", alignItems: "center", flexWrap: "wrap" }}>
          <input
            type="date"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            style={{
              borderRadius: 8,
              border: dark ? "1px solid #23303c" : "1px solid #e6eef8",
              padding: "0.45rem 0.6rem",
              background: dark ? "#071a26" : "#ffffff",
              color: dark ? "#e6eef8" : "#0f172a",
            }}
          />
          <input
            type="time"
            value={time}
            onChange={(e) => setTime(e.target.value)}
            style={{
              borderRadius: 8,
              border: dark ? "1px solid #23303c" : "1px solid #e6eef8",
              padding: "0.45rem 0.6rem",
              background: dark ? "#071a26" : "#ffffff",
              color: dark ? "#e6eef8" : "#0f172a",
            }}
          />
          <button
            onClick={programarSinPreview}
            disabled={!campanaSeleccionada || isSaving}
            title="Programa la campaña sin abrir la vista previa (esta solo se muestra el día programado)"
            style={{
              background: (!campanaSeleccionada || isSaving) ? "#94a3b8" : "#22c55e",
              color: "#0b1220",
              border: "none",
              borderRadius: 10,
              padding: "0.45rem 0.75rem",
              fontWeight: 800,
              cursor: (!campanaSeleccionada || isSaving) ? "not-allowed" : "pointer",
            }}
          >
            Programar campaña
          </button>
        </div>
      </div>
    </div>

    <button
      style={{
        background: (!campanaSeleccionada || isSaving) ? "#1f7fab" : "#28a7e0",
        color: "#fff",
        borderRadius: 12,
        border: "none",
        padding: "0.95rem 0",
        fontWeight: 700,
        fontSize: "1.05rem",
        width: "100%",
        marginTop: "0.8rem",
        boxShadow: dark ? "0 10px 30px rgba(2,8,18,0.45)" : "0 10px 30px rgba(16,24,40,0.08)",
        opacity: (!campanaSeleccionada || isSaving) ? 0.85 : 1,
        cursor: (!campanaSeleccionada || isSaving) ? "not-allowed" : "pointer",
        transition: "transform .12s ease",
      }}
      onClick={openPreview}
      disabled={!campanaSeleccionada || isSaving}
    >
      {isSaving ? "Guardando…" : "Revisar y Enviar"}
    </button>
  </section>

      </main>
      {previewOpen && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", padding: 16, zIndex: 1000 }}>
          <div style={{ width: "min(980px, 96vw)", maxHeight: "92vh", background: "#0f172a", border: "1px solid #1f2937", borderRadius: 12, display: "flex", flexDirection: "column" }}>
            {/* Header */}
            <div style={{ padding: 20, borderBottom: "1px solid #1f2937", display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12 }}>
              <h3 style={{ margin: 0 }}>Vista previa de envío</h3>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <span
                  title="Estado de conexión de WhatsApp"
                  style={{
                    display: 'inline-block',
                    padding: '6px 10px',
                    borderRadius: 999,
                    fontSize: 13,
                    fontWeight: 700,
                    background: waReady === null
                      ? 'linear-gradient(90deg,#94a3b8,#cbd5e1)'
                      : (waReady
                        ? 'linear-gradient(90deg,#10b981,#06b6d4)'
                        : 'linear-gradient(90deg,#f59e0b,#f97316)') ,
                    color: waReady ? '#ffffff' : (waReady === null ? '#0b1220' : '#0b1220'),
                    boxShadow: '0 4px 14px rgba(0,0,0,0.15)'
                  }}
                >
                  {waReady === null ? 'Comprobando…' : (waReady ? 'Conectada' : 'En espera')}
                </span>
                <button onClick={() => { setPreviewOpen(false); }} title="Cerrar" aria-label="Cerrar" style={{ background: "transparent", color: "#94a3b8", border: "none", fontSize: 18, cursor: 'pointer' }}>✕</button>
              </div>
            </div>
            {/* Content scrollable */}
            <div style={{ padding: 20, overflow: "auto" }}>
              <div style={{ color: "#94a3b8", marginBottom: 12 }}>
                {(() => { const n = getSelectedTemplates().length; return `Se enviarán ${recipients.length} mensajes, con intervalo aleatorio entre 7 y 20 segundos, asignando plantillas 1→${n} en ciclo.`; })()}
              </div>
              {/* Bloque de adjuntar imagen opcional eliminado por solicitud */}
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                {getSelectedTemplateEntries().map((e) => (
                  <div key={`slot-${e.slot}-${e.id || 'unset'}`} style={{ background: "#0b1220", border: "1px solid #2a3547", borderRadius: 12, padding: 12 }}>
                    <div style={{ color: "#28a7e0", fontWeight: 600, marginBottom: 6 }}>Plantilla {e.slot}: {e.data?.title || (e.id ? `#${e.id}` : '— sin seleccionar —')}</div>
                    <div style={{ color: "#e2e8f0", fontSize: 14, whiteSpace: "pre-wrap" }}>
                      {e.data ? (
                        <>
                          {htmlToPlain(e.data.content).slice(0, 300)}
                          {htmlToPlain(e.data.content).length > 300 ? "…" : ""}
                        </>
                      ) : (
                        <span style={{ opacity: 0.7 }}>No encontrada o aún cargando…</span>
                      )}
                    </div>
                  </div>
                ))}
              </div>
              <div style={{ position:'relative', marginTop: 12, background: "#0b1220", border: "1px solid #2a3547", borderRadius: 12, padding: 12 }}>
                {(sending || batch) && (
                  <button
                    onClick={() => setPreviewOpen(false)}
                    aria-label="Cerrar ventana"
                    title="Cerrar ventana"
                    style={{
                      position:'absolute',
                      top:4,
                      right:4,
                      background:'rgba(255,255,255,0.05)',
                      border:'1px solid #334155',
                      color:'#cbd5e1',
                      width:24,
                      height:24,
                      lineHeight:'20px',
                      fontSize:14,
                      borderRadius:6,
                      cursor:'pointer'
                    }}
                  >✕</button>
                )}
                <div style={{ color: "#cbd5e1" }}>Destinatarios: {recipients.length}</div>
                {sending && !batch && (
                  <div style={{ marginTop: 8, color: "#e2e8f0" }}>
                    Progreso (cliente): {sendProgress.current}/{sendProgress.total} · Éxitos: {sendProgress.sent} · Fallos: {sendProgress.failed}
                  </div>
                )}
                {batch && (
                  <div style={{ marginTop: 8, color: "#e2e8f0" }}>
                    Progreso (desatendido): {batch.sent||0}/{(batch.total)||( (batch.sent||0)+(batch.failed||0) )} · Fallidos: {batch.failed||0} · Estado: {batch.status}
                  </div>
                )}
              </div>
            </div>
            {/* Footer fijo con botones */}
            <div style={{ padding: 20, borderTop: "1px solid #1f2937", display: "flex", justifyContent: "flex-end", gap: 8 }}>
              {!sending && sendNow && !batch && (
                <button onClick={startSending} disabled={!campanaSeleccionada} style={{ background: !campanaSeleccionada ? "#94a3b8" : "#0d6efd", color: "#fff", border: "none", borderRadius: 8, padding: "0.6rem 0.9rem", fontWeight: 600, cursor: !campanaSeleccionada ? "not-allowed" : "pointer" }}>Envío local</button>
              )}
              {/* Botón de "Envío desatendido" removido temporalmente por solicitud */}
              {batch && batch.status==='running' && (
                <button onClick={()=>{ cancelServerBatch(); }} style={{ background: "#ef4444", color: "#fff", border: "none", borderRadius: 8, padding: "0.6rem 0.9rem", fontWeight:600 }}>Cancelar desatendido</button>
              )}
              {!sending && !sendNow && (
                <button
                  onClick={() => {
                    const plantillasSel = getSelectedTemplates();
                    if (plantillasSel.length < 4) {
                      showToast("Selecciona al menos 4 plantillas", "warning");
                      return;
                    }
                    if (recipients.length === 0) return;
                    if (!campanaSeleccionada) {
                      showToast("Debes seleccionar una campaña guardada para poder programar.", "warning", 5000);
                      return;
                    }
                    const dtStr = `${date} ${time}`.trim();
                    const dt = new Date(dtStr.replace(/-/g, '/'));
                    if (!(dt instanceof Date) || isNaN(dt.getTime()) || dt.getTime() <= Date.now()) {
                      showToast('El tiempo programado no puede ser menor al tiempo y fecha actual', 'warning', 5000);
                      return;
                    }
                    try {
                      // intervalMs queda ignorado: lógica aleatoria en el gestor
                      // Programar localmente y persistir fecha en backend para que el Calendario lo muestre
                      scheduleJob({ at: dt, recipients, templates: plantillasSel, campaign: String(campanaSeleccionada) });
                      (async () => {
                        try {
                          const fechaStr = `${date} ${time}`;
                          const listId = String(listaClientes || '').trim();
                          const payload = listId ? { fecha: fechaStr, clientes: listId } : { fecha: fechaStr };
                          await api.patch(`campanas/${campanaSeleccionada}/`, payload);
                        } catch {}
                      })();
                      showToast('Envío programado', 'success');
                      setPreviewOpen(false);
                    } catch (e) {
                      showToast(e?.message || 'No se pudo programar', 'error');
                    }
                  }}
                  disabled={!campanaSeleccionada}
                  style={{ background: !campanaSeleccionada ? "#94a3b8" : "#22c55e", color: "#0b1220", border: "none", borderRadius: 8, padding: "0.6rem 0.9rem", fontWeight: 700, cursor: !campanaSeleccionada ? "not-allowed" : "pointer" }}
                >
                  Programar y Enviar
                </button>
              )}
              {sending && !batch && (
                <button onClick={() => { stopJob(); setSending(false); }} style={{ background: "#ef4444", color: "#fff", border: "none", borderRadius: 8, padding: "0.6rem 0.9rem", fontWeight: 600 }}>Parar local</button>
              )}
              {!sending && (
                <button onClick={() => setPreviewOpen(false)} style={{ background: "#1f2937", color: "#fff", border: "1px solid #2a3547", borderRadius: 8, padding: "0.6rem 0.9rem" }}>Cerrar</button>
              )}
            </div>
          </div>
        </div>
      )}
      {/* Toast Container */}
      {toast && (
        <div style={{ position: "fixed", top: 20, right: 20, zIndex: 2000 }}>
          <div
            style={{
              background:
                toast.type === "success"
                  ? "#28a745"
                  : toast.type === "error"
                  ? "#dc3545"
                  : toast.type === "warning"
                  ? "#ffc107"
                  : "#28a7e0",
              color: toast.type === "warning" ? "#232d3b" : "#fff",
              padding: "0.75rem 1rem",
              borderRadius: 8,
              minWidth: 240,
              boxShadow: "0 6px 20px rgba(0,0,0,0.25)",
            }}
          >
            {toast.message}
          </div>
        </div>
      )}
    </div>
  );
}

export default Mensajes;
